export default "__VITE_ASSET__Cgu2aVXS__"